module.exports = __webpack_public_path__ + "img/analysis-vendor.35751aeb.svg";